"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Gets the theme details from the theme registry
 * @param {themePropType}                selectedTheme The selected theme name
 * @param {themeRegistryPropType} themeRegistry The theme registry
 * @returns {themePropType}
 */
var getThemeFromRegistry = function getThemeFromRegistry(selectedTheme, themeRegistry) {
  return selectedTheme && themeRegistry && themeRegistry[selectedTheme.themeName] ? themeRegistry[selectedTheme.themeName] : null;
};

var _default = getThemeFromRegistry;
exports.default = _default;